export default "__VITE_ASSET__BGVfEj5E__"